export const GROUP_ORDER = [
  "domain",
  "subdomains",
  "organization",
  "extended"
]

export const ACTIVE = [
  {"domain": ["218"]},
  {"subdomains": ["222"]},
  {"organization": ["237"]},
  {"extended": ["234"]},
]

export const PROMO = [
  {"subdomains": ["222"]}
]

export const TABLE = [
  "name",
  "greatFor",
  "assurance",
  "validation",
  "issuance",
  "price"
]

export const DETAILS = [
  "validation",
  "issuance",
  "encryption",
  "browserSupport",
  "subdomainsProtection",
  "companyNameInSSLDetails",
  "mobileSupport",
  "warranty",
  "refund",
  "trustSeal",
  "sealInSearch"
]

export const DETAILS_TOOLTIP = [
  "issuance",
  "warranty",
  "trustSeal",
  "sealInSearch"
]
